import HttpClient from "./HttpClient";

export default class Address {
  constructor(address) {
    this.id = address.id;
    this.country = address.country;
    this.post_code = address.post_code;
    this.city = address.city;
    this.ref = address.ref;
    this.phone = address.phone;
    this.customer_id = address.customer_id;
    this.created_at = address.created_at;
    this.updated_at = address.updated_at;
    this.street = address.street;
  }

  static async loadAddresses(data){
      const client = new HttpClient();
      const response = await client.instance.get("addresses", data);
      const addresses = [];
      response.data.forEach(element => {
        addresses.push(new Address(element));
      });
      return addresses;
  }

  static async create(data){
    const client = new HttpClient();
    const response = await client.instance.post("addresses", data);
    return response.data;
  }

  static async update(id, data){
    const client = new HttpClient();
    const response = await client.instance.put(`addresses/${id}`, data);
    return response.data;
  }

  async delete(){
    const client = new HttpClient();
    const response = await client.instance.delete(`addresses/${this.id}`);
    return response.data;
  }

  toString() {
    if (this == null)return "";
    const street = this.street ? this.street : "";
    const city = this.city ? this.city : "";
    return street + ", " + city;
  }
}
